import {
  Component, Inject, forwardRef,
  NgModule,
  ViewEncapsulation
} from '@angular/core';

import { OSideMenuModule, OSideMenuComponent } from './o-side-menu.component';
import { OSharedModule } from '../../shared';
import { CommonModule } from '@angular/common';


export class OSideMenuSeparatorComponent {

  protected menu: OSideMenuComponent;

  constructor(  menu: OSideMenuComponent) {
    this.menu = menu;
  }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'o-side-menu-separator',
  template: `
    <hr />
  `,
  styles: [`
    o-side-menu-separator hr{border-width:1px;border-color:#eee;border-style:solid;margin:0px;padding:0px}
  `],
  encapsulation: ViewEncapsulation.None
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: OSideMenuComponent, decorators: [{ type: Inject, args: [forwardRef(() => OSideMenuComponent), ] }, ]},
];
}


export class OSideMenuSeparatorModule {
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: [OSideMenuSeparatorComponent],
  imports: [OSharedModule, CommonModule, OSideMenuModule],
  exports: [OSideMenuSeparatorComponent]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
